import { render, staticRenderFns } from "./NewsImageFallback.vue?vue&type=template&id=102de625&"
var script = {}
import style0 from "./NewsImageFallback.vue?vue&type=style&index=0&id=102de625&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports